import { Fragment } from 'react/jsx-runtime';
import { Button, ButtonProps } from './Button';
import { CloseButton, Popover, PopoverButton, PopoverPanel, useClose } from '@headlessui/react';
import { MouseEvent } from 'react';

type Props = Omit<ButtonProps, 'onClick'> & {
  cancelText?: string,
  caption?: string,
  confirmText?: string,
  onConfirm: (e: MouseEvent) => void
};

type InnerConfirmButtonProps = {
  confirmText: string,
  onConfirm: (e: MouseEvent) => void
}

const InnerConfirmButton = ({ confirmText, onConfirm }: InnerConfirmButtonProps) => {
  const close = useClose();
  return (
    <Button
      className='p-1'
      onClick={(e) => { close(); onConfirm(e); }}
    >
      {confirmText}
    </Button>
  );
};

export const ConfirmButton = ({
  cancelText='No',
  caption='Are you sure?',
  confirmText='Yes',
  onConfirm,
  ...props
}: Props) => {

  return (
    <Popover as={Fragment}>
      <PopoverButton
        as={Button}
        {...props}
      />
      <PopoverPanel
        anchor='bottom'
        className='p-4 bg-red-600 text-white z-50 rounded-sm min-w-[250px]'
      >
        {caption}
        <div className='flex my-2'>
          <InnerConfirmButton
            confirmText={confirmText}
            onConfirm={onConfirm}
          />
          <CloseButton
            as={Button}
            className='p-1'
          >
            {cancelText}
          </CloseButton>
        </div>
      </PopoverPanel>
    </Popover>
  );
};
